module.exports = __webpack_public_path__ + "static/media/netlify.b44224c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/netlify.png
// module id = 163
// module chunks = 0